import styles from './section-14-no-results.module.scss';
import { clsx } from 'clsx';
import { Typography, Icon, ICONS_ENUM } from '@sanlam-glacier/app-common/components';
import { Section14NegativeJourneyCategory } from '../../../types/section-14/section-14.enums';

type Section14NoResultsProps = {
  negativeJourneyType?: Section14NegativeJourneyCategory;
  searchTerm?: string;
  selectedFilters?: string[];
};

export const Section14NoResults = ({
  negativeJourneyType,
  searchTerm,
  selectedFilters
}: Section14NoResultsProps) => {
  if (negativeJourneyType === Section14NegativeJourneyCategory.search) {
    return (
      <div className={clsx(styles.section14NoResultsContainer, styles.searchNoResults)}>
        <Icon icon={ICONS_ENUM.ACTION_2_YOUTUBE_SEARCHED_FOR} className={styles.icon} />
        <div className={styles.noSearchResultsText}>
          <Typography
            variant={Typography.VARIANT.B2}
            weight={Typography.WEIGHT.NORMAL}
            color={Typography.COLOR.INHERIT}
          >
            {searchTerm ? (
              <>
                <span>{`No results found for “`}</span>
                <span className={styles.searchTerm}>{searchTerm}</span>
                <span>{`”.`}</span>
              </>
            ) : (
              'No results found.'
            )}
          </Typography>
          <Typography
            variant={Typography.VARIANT.B2}
            weight={Typography.WEIGHT.NORMAL}
            color={Typography.COLOR.INHERIT}
          >
            Please try another search.
          </Typography>
        </div>
      </div>
    );
  }

  if (
    negativeJourneyType === Section14NegativeJourneyCategory.filter &&
    selectedFilters !== undefined
  ) {
    return (
      <div className={clsx(styles.section14NoResultsContainer)}>
        <div className={styles.filterNoResultsHeaderText}>
          <Icon icon={ICONS_ENUM.ACTION_2_INFO} className={styles.icon} />
          <Typography
            variant={Typography.VARIANT.B2}
            weight={Typography.WEIGHT.MEDIUM}
            color={Typography.COLOR.SECONDARY}
          >
            {selectedFilters.length === 1
              ? `There are no fee renewals “${selectedFilters[0]}”.`
              : `There are no fee renewals due within the selected timeframes.`}
          </Typography>
        </div>
        <Typography
          variant={Typography.VARIANT.B3}
          weight={Typography.WEIGHT.NORMAL}
          color={Typography.COLOR.SECONDARY}
        >
          {selectedFilters.length === 1
            ? `When a fee renewal is “${selectedFilters[0]}”, it will be displayed here.`
            : `When a fee renewal is due within the selected timeframes, it will be displayed here.`}
        </Typography>
      </div>
    );
  }

  return <div className={styles.toDoListNoResultsContainer}>No results found.</div>;
};
